import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import "flag-icons/css/flag-icons.min.css"

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)